import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { MensajeDTO } from 'src/app/global/interfaces/general-response';

import _ from 'lodash';
import { FirmaService } from 'src/app/global/services/firma.service';
import { environment } from 'src/environments/environment';

@Injectable()
export class Firmaprovider extends FirmaService {

    private basUrl = _.get(environment, 'api.host');
    private basePath = _.get(environment, 'api.path', '');
    private baseEndpoint = _.get(environment, 'api.endpoints');
    private endpoint: string;


    constructor(
        private http: HttpClient
    ) {
        super();
    }

    /**
     * @description Método que sirva para obtener el resultado de la firma
     * @returns Retorna un OBservable de MensajeDTO
     */
    public validStatusFirm(estado: string): Observable<MensajeDTO> {
        this.endpoint = this.basUrl + this.basePath + _.get(this.baseEndpoint, 'PASO_3.VALIDA_ESTADO_FIRMA') + '?estado=' + estado;
        return this.http.get<MensajeDTO>(this.endpoint);
    }
}
